// extracted by mini-css-extract-plugin
export default {"mainContainer":"bl_f2","contentViewport":"bl_f3"};